<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Kontakte</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" (keyup.enter)="SaveKontackt()">
  @if(Kontakte != null)
  {
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Name</th>
        <th scope="col">Beziehung</th>
        <th scope="col">Addesse</th>
        <th scope="col">Telefon</th>
        <th scope="col">Mail</th>
        <th scope="col">Info</th>
        <th scope="col" *IsSpezialUser><i class="btn btn-success btn-sm bi bi-person-plus" (click)="addNew()"></i></th>
      </tr>
    </thead>
    <tbody>
      @for (contact of Kontakte; track contact.key; let i = $index) {
      <tr>
        <td>
          {{ contact.anrede }} {{ contact.vorname }} {{ contact.nachname }}
        </td>
        <td>
          {{ contact.bezihung }}
        </td>
        <td>
          {{ addressString(contact) }}
        </td>
        <td>
          {{ contact.phone }} {{ contact.phone2 }}
        </td>
        <td>
          {{ contact.email }}
        </td>
        <td>
          <span title="{{ contact.info }}" style="text-overflow:ellipsis; white-space:none">{{ contact.info }}</span>
        </td>
        <td *IsSpezialUser>
          <i class="btn btn-primary btn-sm bi bi-pen" (click)="selectKontakt(contact)"></i>
          <i class="btn btn-danger btn-sm bi bi-person-dash-fill" (click)="DeleteKontakt(contact.key)"></i>
          @if(i > 0)
          {<i class="btn btn-primary btn-sm bi bi-chevron-up" (click)="changeOrder(contact, i - 1)"></i>}
          @if(i < Kontakte.length - 1)
          {<i class="btn btn-primary btn-sm bi bi-chevron-down" (click)="changeOrder(contact, i + 1)"></i>}
        </td>
      </tr>
      }
    </tbody>
  </table>
  }
  @if(EditKontakte != null)
  {

  <hr />


  <div class="row">
    <div class="col-3"><GeschlechtsAuswahl [Geschlecht]="EditKontakte.geschlecht?? 0" (GeschlechtChange)="EditKontakte.geschlecht = $event"></GeschlechtsAuswahl></div>
    <div class="col-3">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Anrede" [(ngModel)]="EditKontakte.anrede">
        <label for="Anrede">Anrede</label>
      </div>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Vorname" [(ngModel)]="EditKontakte.vorname">
        <label for="Vorname">Vorname</label>
      </div>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Nachname" [(ngModel)]="EditKontakte.nachname">
        <label for="Nachname">Nachname</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Telefon" Phonenumber [(ngModel)]="EditKontakte.phone">
        <label for="Telefon">Telefon</label>
      </div>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Telefon2" Phonenumber [(ngModel)]="EditKontakte.phone2">
        <label for="Telefon2">Telefon (Alternativ)</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="col">
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="Mail" [(ngModel)]="EditKontakte.email">
          <label for="Mail">Mail</label>
        </div>
      </div>

    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="Bezihung" [(ngModel)]="EditKontakte.bezihung">
        <label for="Bezihung">Beziehung</label>
      </div>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="SchluesselVorhanden" [(ngModel)]="SchluesselVorhanden">
        <label for="SchluesselVorhanden">Schlüssel Vorhanden</label>
      </div>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input type="number" class="form-control" id="Fahrzeit" [(ngModel)]="Fahrzeit">
        <label for="Fahrzeit">Fahrzeit In min.</label>
      </div>
    </div>
  </div>
  <div class="row" *IsVolleBerechtigung>
    <div class="col">
      <div class="form-check mb-3">
        <input name="istMitbewohner" id="istMitbewohner" class="form-check-input" type="checkbox"
               [checked]="EditKontakte.istExtraTeilnehmer"
               (change)="EditKontakte.istExtraTeilnehmer = !EditKontakte.istExtraTeilnehmer" />
        <label for="istMitbewohner" class="form-check-label">Extrateilnehmer</label>
      </div>
    </div>
  </div>
    @if(EditKontakte.istExtraTeilnehmer){
    <div class="row"  *IsVolleBerechtigung >
      <div class="col">
        <div class="form-floating mb-3">
          <textarea type="text" class="form-control" id="Info" [(ngModel)]="EditKontakte.medikamente"></textarea>
          <label for="Info">Medekamente</label>
        </div>
      </div>
      <div class="col">
        <div class="form-floating mb-3">
          <textarea type="text" class="form-control" id="Info" [(ngModel)]="EditKontakte.erkrankung"></textarea>
          <label for="Info">Krankheiten</label>
        </div>
      </div>
      <div class="col">
        <div class="form-floating mb-3">
          <input type="number" class="form-control" id="Pflegegrad" [(ngModel)]="EditKontakte.pflegegrad">
          <label for="Pflegegrad">Pflegegrad</label>
        </div>
      </div>
    </div>
    }
  <Address [(address)]="adresse"></Address>
  <div class="col">
    <div class="form-floating mb-3">
      <textarea type="text" class="form-control" id="Info" [(ngModel)]="EditKontakte.info"></textarea>
      <label for="Info">Info</label>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="btn btn-primary" (click)="SaveKontackt()" *IsSpezialUser>Speichern</div>
    </div>
  </div>
  }
</div>
